module.exports = __webpack_public_path__ + "img/card-bg-01.54632842.png";